/* eslint-disable no-shadow */
import { withStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";

import * as generalActions from "../../actions/general";
import ReactPlaceholder from "react-placeholder";
import "react-placeholder/lib/reactPlaceholder.css";
import styles from "./styles";

import Seo from "../../components/Seo";
import {
  Sliders,
  ProjectComponent,
  ContactUs,
  Progress,
  NewsHome
} from "../../components/Home";

function Homepage(props) {
  const {
    generalActionCreators,
    sliders,
    projectCate,
    projects,
    loading,
    news,
    generalContent,
  } = props;

  const { fetchSlider, fetchProjectById, fetchNews } = generalActionCreators;

  useEffect(() => {
    fetchSlider();
    fetchNews();
    window.addEventListener("scroll", handleScroll);
  }, [fetchSlider, fetchNews]);

  const handleScroll = e => {
    // console.log(e);
  };

  return (
    <div>
      <Seo seoContent={generalContent} />
      <ReactPlaceholder
        style={{ height: "calc(100vh - 120px - 60px)", width: "100%" }}
        type="rect"
        ready={sliders.length > 0}
        color="#E0E0E0"
        showLoadingAnimation={true}
      >
        <Sliders sliders={sliders} />
      </ReactPlaceholder>

      <ProjectComponent
        fetchProjectById={fetchProjectById}
        projectCate={projectCate}
        projects={projects.slice(0, 6)}
        loading={loading}
      />
      <ContactUs />
      <Progress />
      <NewsHome news={news} />
    </div>
  );
}

const mapStateToProps = state => ({
  sliders: state.general.sliders,
  projectCate: state.general.projectCate,
  projects: state.general.projects,
  loading: state.general.loading,
  news: state.general.news,
  generalContent: state.general.generalContent,
});

const mapDispatchToProps = dispatch => ({
  generalActionCreators: bindActionCreators(generalActions, dispatch)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withStyles(styles), withConnect)(Homepage);
